import React from 'react';
import { Link as DvaLink } from 'dva/router';
import { Link as SimpleLink } from '@mos-cat/typography';
import cn from 'classnames';

function Link({ className = '', ...props }) {
  return props.href ? (
    <SimpleLink className={className} {...props} />
  ) : (
    <DvaLink className={cn('mos-link', className)} {...props} />
  );
}

export default Link;
